import axios from 'axios'

const getVersion = () => axios.get('/api/version')

export default {
  getVersion
}
